const RequestTicket = () => {
  return <>adsfs</>;
};

export default RequestTicket;
